import SiteHeader from 'containers/SiteHeader'
import { MetadataUserProvider } from 'contexts/metadata-user-context'
import React, { ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'
import { PrivateRoute } from 'routers/PrivateRoute'
import Footer from 'shared/Footer/Footer'

interface MainTemplateProps {
  children: ReactNode
}

export const MainTemplate: React.FC<MainTemplateProps> = ({ children }) => {
  return (
    <MetadataUserProvider>
      <PrivateRoute>
        <Toaster position="top-center" />
        <main className="w-full min-h-[calc(100svh-144px)]">
          <SiteHeader searchEngine={true} />
          {children}
        </main>
        <Footer />
      </PrivateRoute>
    </MetadataUserProvider>
  )
}
